<template>
    <div>
        <Card>
            <Spin v-if="innerSpin" size="large" fix></Spin>
            <transition name="fade">
                <Row v-if="mainTable.sarchCardShow" :gutter="16">
                    <Col span="24">
                        <search-card
                            :form="mainTable.searchForm"
                            :table-load-event="getDepartmentTableRecords"
                            :table-search="mainTable.tableSearch"
                        />
                    </Col>
                </Row>
            </transition>
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">部门管理</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                class="btns"
                                size="small"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onDepartmentCreate"
                                >新增</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchCardShow =
                                        !mainTable.sarchCardShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getDepartmentTableRecords"
                    />
                </Col>
            </Row>
            <DeptMemberInspectorModal
                ref="deptMemberInspectorModal"
                @refresh="refresh"
            />
            <SeedFarmModal
                ref="seedFarmModal"
                :readOnly="false"
                :distributionStationsOptions="distributionStationsOptions"
                :YSDeptOptions="YSDeptOptions"
                :allRegions="allRegions"
                :areaSource="areaSource"
                @refresh="refresh"
            />
        </Card>
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from "@/view/mixins/form-edit-mode";
import {
    DEPARTMENT_TYPE_BINFEN,
    DEPARTMENT_TYPE_EXTERNAL
} from "@/view/system-management/department-management/DepartmentTypeDefine";
import {
    STATUS_ACTIVE,
    STATUS_INACTIVE,
    statusFormat
} from "@/libs/baseModelFormat";

import {
    getDepartmentList,
    saveDepartment,
    deleteDepartment
} from "@/api/modules/system-management/department-management";
import {
    pageInit4SeedFarmEdit,
    getRelateList
} from "@/api/modules/system-management/seedFarm-management";
import SeedFarmModal from "@/view/seedFarm-management/seedFarm-Modal/seedFarm-modal.vue";
import DeptMemberInspectorModal from "@/view/system-management/department-management/department-modal.vue";
import { webGetAllRegion } from "@/api/modules/system-management/region-management";
import { getDistributionStationList } from "@/api/modules/system-management/distributionStation-management.js";
export default {
    name: "DepartmentList",
    components: {
        StandPaginationTable,
        SearchCard,
        SeedFarmModal,
        DeptMemberInspectorModal
    },
    data() {
        return {
            DEPARTMENT_TYPE_BINFEN,
            DEPARTMENT_TYPE_EXTERNAL,
            readOnly: false,
            innerSpin: false,
            distributionStationsOptions: [],
            YSDeptOptions: [],
            distOptions: [],
            allRegions: [],
            areaSource: [],
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 80,
                        align: "center"
                    },
                    {
                        title: "部门名称",
                        key: "departmentName",
                        align: "center"
                    },
                    {
                        title: "联系人",
                        key: "departmentContact",
                        align: "center"
                    },
                    { title: "手机", key: "departmentPhone", align: "center" },
                    { title: "类型", key: "departmentType", align: "center" },
                    {
                        title: "状态",
                        key: "departmentStatus",
                        align: "center",
                        render: (h, params) => {
                            return h(
                                "span",
                                {
                                    style: {
                                        color: params.row.departmentStatus === STATUS_ACTIVE ? '#52c41a' : '#ff4d4f'
                                    }
                                },
                                statusFormat(params.row.departmentStatus)
                            );
                        }
                    },
                    {
                        title: "部门类型",
                        key: "deptType",
                        align: "center",
                        render: (h, params) => {
                            const text = params.row.deptType === 0 ? "部门" : "苗场";
                            return h(
                                "Tag",
                                {
                                    props: {
                                        color: params.row.deptType === 0 ? 'blue' : 'green'
                                    }
                                },
                                text
                            );
                        }
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        render: (h, params) => {
                            const editButton = h(
                                "Button",
                                {
                                    props: { 
                                        type: "primary", 
                                        size: "small",
                                        ghost: true
                                    },
                                    on: {
                                        click: () => this.onDepartmentUpdate(params.row)
                                    }
                                },
                                "编辑"
                            );

                            const deleteButton = h(
                                "Button",
                                {
                                    props: { 
                                        type: "error", 
                                        size: "small",
                                        ghost: true
                                    },
                                    on: { click: () => this.onDepartmentDel(params.row) }
                                },
                                "删除"
                            );

                            return h("div", { class: "action-buttons" }, [editButton, deleteButton]);
                        }
                    }
                ],
                data: [],
                sarchCardShow: false,
                searchForm: [
                    {
                        label: "部门名称",
                        type: "Input",
                        value: "",
                        name: "departmentName",
                        sql: "like"
                    },
                    {
                        label: "联系人",
                        type: "Input",
                        value: "",
                        name: "departmentContact",
                        sql: "like"
                    },
                    {
                        label: "手机",
                        type: "Input",
                        value: "",
                        name: "departmentPhone",
                        sql: "like"
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    computed: {
        
    },
    mounted() {
        this.initializePageData();
        this.getDepartmentTableRecords();
    },
    methods: {
        async initializePageData() {
            this.innerSpin = true;
            try {
                const [
                    regionData,
                    relateOptionsData,
                    stationData,
                    seedFarmInitData
                ] = await Promise.all([
                    webGetAllRegion(),
                    getRelateList(),
                    getDistributionStationList(this.buildStationListParams()),
                    pageInit4SeedFarmEdit()
                ]);

                if (regionData.code === 0)
                    this.allRegions = regionData.data.allRegions;
                if (relateOptionsData.code === 0)
                    this.YSDeptOptions = relateOptionsData.data.YSDeptOptions;
                if (seedFarmInitData.code === 0) {
                    this.areaSource = seedFarmInitData.data.area.records.map(
                        (item) => ({
                            areaUuid: item.areaUuid,
                            areaName: item.areaName
                        })
                    );
                }
                if (stationData.code === 0) {
                    this.distributionStationsOptions
                        = stationData.data.records.map((item) => ({
                            name: item.distributionStationName,
                            code: item.distributionStationCode,
                            id: item.distributionStationUuid
                        }));
                }
            }
            catch (error) {
                console.error("页面初始化失败:", error);
                this.$Message.error("初始化页面数据时出错。");
            }
            finally {
                this.innerSpin = false;
            }
        },

        getDepartmentTableRecords(reset = false) {
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getDepartmentList(this.mainTable.tableSearch)
                .then((res) => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }
                })
                .finally(() => {
                    this.mainTable.loading = false;
                });
        },
        onDepartmentCreate() {
            this.$refs.deptMemberInspectorModal.showModal(
                FORM_EDIT_MODE_CREATE
            );
        },
        onDepartmentUpdate(row) {
            if (row.deptType == 0) {
                this.$refs.deptMemberInspectorModal.showModal(
                    FORM_EDIT_MODE_MODIFY,
                    row.departmentUuid,
                    row.departmentName,
                    row.departmentContact,
                    row.departmentPhone,
                    row.departmentType,
                    row.departmentStatus,
                    row.companyUuid
                );
            }
            else {
                this.$refs.seedFarmModal.showModal(
                    FORM_EDIT_MODE_MODIFY,
                    row.departmentUuid
                );
            }
        },
        onDepartmentDel(row) {
            this.$Modal.confirm({
                title: "确定删除吗？",
                content: `删除后无法恢复，是否继续删除部门"${row.departmentName}"？`,
                onOk: () => {
                    deleteDepartment({
                        departmentUuid: row.departmentUuid,
                        deptType: row.deptType
                    }).then((res) => {
                        if (res.code === 0) {
                            this.$Message.success("删除成功");
                            this.getDepartmentTableRecords();
                        }
                        else {
                            this.$Message.error(res.message || '删除失败');
                        }
                    }).catch((error) => {
                        console.error('删除部门失败:', error);
                        this.$Message.error('删除失败');
                    });
                }
            });
        },
        buildStationListParams() {
            let data = search.getSearchParams();
            data.filters.conditions.push({
                name: "distributionStationStatus",
                type: "eq",
                value: 1
            });
            data.filters.enable = true;
            data.limit.enable = false;
            return data;
        },
        refresh() {
            this.getDepartmentTableRecords(true);
        }
    }
};
</script>

<style lang="less" scoped>
.form-button {
    margin-top: 5px;
}

.action-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;
}
</style>
